import React from "react";
import PropTypes from "prop-types";
import TerminalSubscriptionDetails from "./terminal-subscription-details/TerminalSubscriptionDetails";
import BulkSubscriptionDetails from "containers/v3/BulkSubscriptionDetailsContainer";
import ZuoraSubscriptionDetails from "./zuora-subscription-details/ZuoraSubscriptionDetails";
import GenericSubscriptionDetails from "./generic-subscription-details/GenericSubscriptionDetails";
import { SUBSCRIPTION_TYPE } from "common/constants/v2/Constants";
import { TERMINAL_PROVIDER, ZUORA_PROVIDER } from "common/utils/subscriptionProvider";

const SubscriptionDetails = (props) => {
    const {
        type,
        provider
    } = props;

    if (provider === TERMINAL_PROVIDER) {
        return <TerminalSubscriptionDetails { ...props } />;
    }

    if (type === SUBSCRIPTION_TYPE.BULK) {
        return <BulkSubscriptionDetails { ...props } />;
    }

    if (provider === ZUORA_PROVIDER) {
        return <ZuoraSubscriptionDetails { ...props } />;
    }

    return <GenericSubscriptionDetails { ...props } />;
};

SubscriptionDetails.propTypes = {
    type: PropTypes.string.isRequired,
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string,
    metadata: PropTypes.shape({
        productType: PropTypes.string
    }),
    hideShippingInfo: PropTypes.bool,
    status: PropTypes.string.isRequired,
    offerType: PropTypes.string,
    bloombergSiteUrl: PropTypes.string.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    admins: PropTypes.array,
    bulkSubscriptionMetadata: PropTypes.object,
    getAdmins: PropTypes.func.isRequired,
    adminPanelUrl: PropTypes.string.isRequired,
    contacts: PropTypes.array
};

export default SubscriptionDetails;
